module.exports = __webpack_public_path__ + "static/media/ExamBankUnlock.01216614.svg";